export interface AlertMessage {
    id: string;
    message: string;
    color?: AlertColor;
    count?: number;
    __typename: 'AlertMessage';
}

export interface AlertsProps {
    alerts: AlertMessage[];
    removeAlert: (alert: { message: string }) => void;
}

export enum AlertColor {
    primary = 'primary',
    secondary = 'secondary',
    success = 'success',
    danger = 'danger',
    warning = 'warning',
    info = 'info',
    light = 'light',
    dark = 'dark'
}

export interface AlertsPayload {
    alerts: AlertMessage[];
}



// WEBPACK FOOTER //
// ./src/client/clientState/alerts/types.ts